import { BaseModel } from "@/models/BaseModel";
import { Document } from "@/models/Document";
import languages from "@/locales/supported-locals.js";
import { TranslatableFieldsMixin } from "@/mixins/TranslatableFieldsMixin.js";

export class Option extends BaseModel {

  static translatableFields = ["feedback", "text",];

  constructor({
    id = null,
    text = null,
    identifier,
    feedback,
    points = 0,
    position = 0,
    image = null,
    language_override = null,
    ...rest
    // question = null // TODO?
  }) {
    super();
    this.id = id;
    this.text = text;
    this.identifier = identifier;
    this.feedback = feedback;
    this.points = points;
    this.position = position;
    this.image = image ? new Document(image) : null;
    this.language_override = language_override;


    // Handle translatable fields.
    TranslatableFieldsMixin.applyTranslation(
      this,
      Option.translatableFields,
      rest,
      languages
    );
  }
}

export default Option;
